export default __webpack_public_path__ + "static/media/discount.539f1ea6.jpg";